import { getApplication } from '@gonfalon/openapi/operations/getApplication';
import { type GetApplicationsQueryParams, getApplications } from '@gonfalon/openapi/operations/getApplications';
import { getApplicationVersionAdoption } from '@gonfalon/openapi/operations/getApplicationVersionAdoption';
import {
  type GetApplicationVersionsQueryParams,
  getApplicationVersions,
} from '@gonfalon/openapi/operations/getApplicationVersions';
import { getApplicationVersionSupported } from '@gonfalon/openapi/operations/getApplicationVersionSupported';
import { internalGetApplicationsByFlag } from '@gonfalon/openapi/operations/internalGetApplicationsByFlag';
import { internalGetApplicationsByProject } from '@gonfalon/openapi/operations/internalGetApplicationsByProject';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { createQueryOptions } from '../internal/createQueryOptions';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

export const getApplicationsQuery = createQueryOptions(getApplications);
export const getApplicationVersionsQuery = createQueryOptions(getApplicationVersions);

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const applications = createQueryKeys('applications', {
  list: ({ params }: { params?: GetApplicationsQueryParams }) => ({
    // Working around some limitations of query-key-factory here.
    //
    // [params] | null is not a valid type for queryKey, so we add a
    // placeholder string ('list') to satisfy the types.
    queryKey: params ? ['list', params] : ['list'],
    queryFn: async ({ signal }) => reactQueryResponseAdapter(getApplications({ query: params }, { signal })),
  }),
  detail: ({ applicationKey }: { applicationKey: string }) => ({
    queryKey: [applicationKey],
    queryFn: async ({ signal }) => reactQueryResponseAdapter(getApplication({ applicationKey }, { signal })),
    contextQueries: {
      versions: ({ params }: { params?: GetApplicationVersionsQueryParams }) => ({
        // Working around some limitations of query-key-factory here.
        //
        // [params] | null is not a valid type for queryKey, so we add a
        // placeholder string ('versions') to satisfy the types.
        queryKey: params ? ['versions', params] : ['versions'],
        queryFn: async () => reactQueryResponseAdapter(getApplicationVersions({ applicationKey, query: params })),
      }),
      versionCount: ({ params }: { params: { supported: boolean } }) => ({
        queryKey: [params],
        queryFn: async () =>
          reactQueryResponseAdapter(getApplicationVersionSupported({ applicationKey, query: params })),
      }),
      versionAdoption: {
        queryKey: null,
        queryFn: async ({ signal }) =>
          reactQueryResponseAdapter(getApplicationVersionAdoption({ applicationKey }, { signal })),
      },
    },
  }),
});

export const internalGetApplicationsByProjectQuery = createQueryOptions(internalGetApplicationsByProject);
export const internalGetApplicationsByFlagQuery = createQueryOptions(internalGetApplicationsByFlag);
